import React from "react";
import { ClientAttachmentsDataTable } from "./";

const ClientAttachmentsPage = () => {
  return (
    <div className="sub-content">
      <ClientAttachmentsDataTable />
    </div>
  );
};

export default ClientAttachmentsPage;



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/clientAttachments/ClientAttachmentsPage.js